/*----------------------------------------------------------------------------
    EditAddTherm.tsx

----------------------------------------------------------------------------*/

import React from 'react';
import '../App.css';
import { makeStyles, Text, Divider, Dialog, DialogTrigger, Button, DialogSurface, DialogBody, DialogTitle, DialogContent, Field, Input, DialogActions, Dropdown, Option, SelectionEvents, OptionOnSelectData } from
    '@fluentui/react-components';
import { InputTypes, RexInput } from '../components/RexInput';
import { FormControls } from "../model/FormControls";
import { IAppContext } from "../model/IAppContext";
import { TheAppContext } from "../model/AppContext";
import { withStyles } from '../components/withStyles';
import { Therm } from "../model/Therm";
import { RexDateTime } from '../Dates/RexDateTime';

export interface OnDismissDelegate
{
    (): void;
}

export interface OnSaveDelegate
{
    (newItem: Therm): void;
}

export interface EditAddThermProps
{
    styles: Record<string, string>;
    isAdd: boolean;
    open?: boolean;
    onSave: OnSaveDelegate;
    onDismiss: OnDismissDelegate;
    itemEditing: Therm;
}

export interface EditAddThermState
{
    itemEditing: Therm;
    isOpen: boolean;
}

const useStyles = makeStyles(
    {
        stackHorizontal:
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        stackVertical:
        {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }
        //        dividerCustom: {
        //            fontSize: '14px',
        //            fontWeight: 'bold'
        //        },
        //        insetContent: {
        //            marginLeft: '.1in',
        //            marginRight: '.1in'
        //        }

    });

class EditAddThermWithoutStyles extends React.Component<EditAddThermProps, EditAddThermState>
{
    context!: IAppContext;
    static contextType = TheAppContext;
    m_controls: FormControls<Therm>;

    constructor(props: EditAddThermProps)
    {
        super(props);
        this.state =
        {
            isOpen: this.props.open ?? false,
            itemEditing: this.props.itemEditing,
        };

        this.m_controls = new FormControls<Therm>(
            [
                ["SmokeID", "smokeID"],
                ["ThermID", "smokeID"],
                ["Description", "description"],
            ]);
    }

    async componentDidMount()
    {
        this.m_controls.updateForData(this.state.itemEditing);
    }

    async componentDidUpdate(prevProps: EditAddThermProps, prevState: EditAddThermState)
    {
        if (prevProps.itemEditing != this.props.itemEditing)
        {
            this.m_controls.updateForData(this.state.itemEditing);
            this.setState(
                {
                    itemEditing: this.props.itemEditing,
                });
        }
    }

    async onCommit(formEvent: React.FormEvent)
    {
        formEvent.preventDefault(); // don't auto dismiss

        // need to query the DOM and populate the item from that to allow
        // autofill (which doesn't fire any events)
        const newItem = this.m_controls.getDataFromFormForEvent(formEvent);

        newItem.SmokeID = this.state.itemEditing.SmokeID;

        this.props.onSave(newItem);
    }

    handleInputChange(field: string, value: string)
    {
        const valueToUse = value;

        this.setState(
            (prevState) => ({
                itemEditing:
                {
                    ...prevState.itemEditing,
                    [field]: valueToUse
                }
            }));
    }

    dismissDialog()
    {
        this.props.onDismiss();
    }

    render()
    {
        const therm = this.state.itemEditing;
        const onChange = this.handleInputChange.bind(this);
        const dismissOpen = () => this.dismissDialog();
        const adding = this.props.isAdd;

        return (
            <Dialog modalType="modal" open={this.props.open}>
                <DialogSurface>
                    <form onSubmit={(event) => this.onCommit(event)}>
                        <DialogBody>
                            <DialogTitle>Therm</DialogTitle>
                            <DialogContent className={this.props.styles.content}>
                                <RexInput label="Therm ID" controls={this.m_controls} controlName="ThermID" style={{ width: '16em' }} onChange={onChange} value={therm.ThermID}/>
                                <RexInput label="Description" controls={this.m_controls} controlName="Description" style={{ width: '32em' }} onChange={onChange} value={therm.Description}/>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={dismissOpen} appearance="secondary">Cancel</Button>
                                <Button type="submit" appearance="primary">Save</Button>
                            </DialogActions>
                        </DialogBody>
                    </form>
                </DialogSurface>
            </Dialog>)
    }
}

export const EditAddTherm = withStyles(useStyles, EditAddThermWithoutStyles);